import React, { useState } from "react";
import "../css/VehicleList.css";
import ArrowDropUpIcon from "@mui/icons-material/ExpandLess";
import ArrowDropDownIcon from "@mui/icons-material/ExpandMore";
const VehicleList = ({ vehicles }) => {
  return (
    <div className="vehicle-list" data-testid="vehicle-list">
      <p data-testid="vehicle-list-title">Vehicles</p>

      {vehicles === undefined || vehicles.length === 0 ? (
        <p className="no-vehicle-message" data-testid="no-vehicle-message">No vehicle added</p>
      ) : (
        <div className="vehicle-list-box" data-testid="vehicle-list-box">
          {vehicles.map((vehicle, index) => (
            <VehicleItem key={index} vehicle={vehicle} index={index} />
          ))}
        </div>
      )}
    </div>
  );
};

const VehicleItem = ({ index, vehicle }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="vehicle-item" >
      <div className="vehicle-header" onClick={toggleExpand}>
        <p className="vehicle-name">{`Vehicle ${index + 1}`}</p>
        <span className="vehicle-toggle-icon">
          {isExpanded ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
        </span>
      </div>

      {isExpanded && (
        <div className="vehicle-details">
          <p>
            <strong>Model of The Vehicle:</strong> {vehicle.vehicleName}
          </p>
          <p>
            <strong>Registration Number:</strong> {vehicle.licensePlateNumber}
          </p>
          <p>
            <strong>Driver's Name:</strong> {vehicle.driverName}
          </p>
          <p>
            <strong>Vehicle Type:</strong> {vehicle.escortVehicleType}
          </p>
        </div>
      )}
    </div>
  );
};

export default VehicleList;
